import { QueryProvider as ObservabilityQueryProvider } from '@gonfalon/observability-graphql/components/QueryProvider/QueryProvider';
import { Box } from '@gonfalon/observability-ui/components/Box';
import { useObservabilityTheme } from '@gonfalon/observability-ui/hooks/useObservabilityTheme';
import { ObservabilityDependencyAdapter } from '@gonfalon/observability/components/ObservabilityDependencyAdapter/ObservabilityDependencyAdapter';
import { AgentInsightsProvider } from '@gonfalon/vega/AgentInsightsContext';

// oxlint-disable-next-line import/no-unassigned-import
import '@gonfalon/observability-ui/theme';
// oxlint-disable-next-line import/no-unassigned-import
import '@gonfalon/vega/styles';

import styles from './VegaPanel.module.css';

export const VegaWrappers: React.FC<React.PropsWithChildren> = ({ children }) => {
  useObservabilityTheme();

  return (
    <ObservabilityQueryProvider>
      <AgentInsightsProvider>
        <ObservabilityDependencyAdapter>
          <Box cssClass={['observability-root-layout', styles.wrapper]}>{children}</Box>
        </ObservabilityDependencyAdapter>
      </AgentInsightsProvider>
    </ObservabilityQueryProvider>
  );
};
